<template>
    <div class="squeeze-container">
      <!-- <header class="squeeze-header">
        <div class="brand-wrapper">
          <span class="brand-logo">SHELTA</span>
          <span class="badge">LANDLORD INTELLIGENCE</span>
        </div>
      </header> -->
  
      <main class="squeeze-content">
        <div class="grid-layout">
          
          <section class="copy-column">
            <p class="eyebrow-text">SHELTA FREE COMPLIANCE RESOURCE</p>
            <h1 class="headline">The Nigerian Landlord’s Essential Risk Checklist</h1>
            <p class="subheadline">
              Protect your rental yields and secure legal bulletproofing. Avoid high-risk tenancy pitfalls with our validated execution guide built specifically for Nigerian real estate.
            </p>
  
            <div class="inside-box">
              <h3>What’s Inside the Checklist:</h3>
              <ul class="features-list">
                <li>
                  <strong>Tenant Vetting Protocols:</strong> The exactly non-negotiable verification documents needed prior to key handover.
                </li>
                <li>
                  <strong>Rent Recovery Framework:</strong> Legal provisions ensuring protection against professional defaults and bad faith occupants.
                </li>
                <li>
                  <strong>Eviction Guard Metrics:</strong> Bulletproof processes aligned cleanly with state tenancy laws to optimize structural risk.
                </li>
              </ul>
            </div>
  
            <div class="authority-strip">
              <div class="stat-item">
                <span class="stat-number">100%</span>
                <span class="stat-desc">Legally Verified Protocols</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">₦50 Billion+</span>
                <span class="stat-desc">Rental Assets Protected</span>
              </div>
            </div>
          </section>
  
          <section class="form-column">
            <div class="form-card">
              <h2 class="form-title">Access the Checklist Immediately</h2>
              <p class="form-subtitle">Enter your credentials below to secure tenant checklists</p>
              
              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label for="email">Email Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    v-model="form.email" 
                    placeholder="e.g., landlord@domain.com" 
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="phone">Phone number</label>
                  <input 
                    type="number" 
                    id="phone" 
                    v-model="form.phone" 
                    placeholder="eg., 08012345678" 
                    required
                  />
                </div>
  
                <div class="form-group">
                  <label for="state">Primary Property Location State</label>
                  <select id="state" required v-model="form.state_id">
                    <option value="" disabled selected>Select your property state</option>
                    <option v-for="state in states" :key="state.id" :value="state.id">
                      {{ state.name }}
                    </option>
                  </select>
                </div>
  
                <button type="submit" class="submit-button" :disabled="isSubmitting">
                  <span>{{ isSubmitting ? 'Verifying Credentials...' : 'Send Checklist' }}</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </button>
              </form>
            </div>
          </section>
  
        </div>
      </main>
    </div>
  </template>
  
<script>
  import Vue from 'vue';
  import { Service } from "../../store/service";
  const Api = new Service();
  export default {
    name: 'SqueezePage',
    data() {
      return {
        isSubmitting: false,
        form: {
          email: '',
          state_id: '',
          phone: '',
        },
        states: [],
        stateId: "",
      };
    },
    mounted() {
        // this.fetchStates();
        this.getStates();
    },
    methods: {
      async handleSubmit() {
        this.isSubmitting = true;
        try {
            Api.postRequest('potential-landlord-mail', {
                state_id: this.form.state_id, email: this.form.email, phone: this.form.phone
            }).then(res => {
                // console.log("Submitted res", res);
                this.isSubmitting = false;
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                    this.$emit('submit', { ...this.form });
                }
            }).catch(err => {
                console.log("Error", err);
                this.isSubmitting = false;
            })
        } finally {
            // console.log("closed")
        }

        // setTimeout(() => {
        //   this.isSubmitting = false;
        //   this.$emit('submit', { ...this.form });
        // }, 1200);
    },
        async getStates() {
            this.$store.commit("setApiWarning", "Loading state...");
            try {
                await Api.getRequest(`fetchstatesbycountryid/${161}`)
                .then(res => {
                    // console.log("stateeees", res)
                    if (res.data.success) {
                    this.states = res.data.states;
                    // return this.$store.commit("setApiSuccess", res.data.success);
                    } else if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                    }
                })
                .catch(err => {
                    // this.loader2 = false;
                    console.log(err);
                });
            } finally {
                // console.log("Closed connection");
            }
        },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  $primary: #0f172a;
  $accent: #0284c7;
  $text-dark: #1e293b;
  $text-muted: #64748b;
  $border: #e2e8f0;
  
  .squeeze-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f8fafc;
    margin-top: 9rem;
  }
  
  .squeeze-header {
    padding: 1.5rem 1rem;
    border-bottom: 1px solid $border;
    background: #ffffff;
  
    .brand-wrapper {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      gap: 1rem;
  
      .brand-logo {
        font-weight: 900;
        font-size: 1.5rem;
        letter-spacing: -0.05em;
        color: $primary;
      }
  
      .badge {
        font-size: 0.7rem;
        font-weight: 700;
        background: #f1f5f9;
        color: $accent;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        letter-spacing: 0.05em;
      }
    }
  }
  
  .squeeze-content {
    flex: 1;
    padding: 2rem 1rem;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  
  .grid-layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;
    width: 100%;
  }
  
  .copy-column {
    .eyebrow-text {
      color: $accent;
      font-weight: 800;
      font-size: 0.85rem;
      letter-spacing: 0.1em;
      margin-bottom: 0.75rem;
    }
  
    .headline {
      color: $primary;
      text-align: left;
    //   font-size: 2.25rem;
    font-family: Lato;
      line-height: 1.3;
      font-weight: 500;
      margin-bottom: 1.5rem;
      letter-spacing: -0.02em;
      color: #1A1A1A !important;
      font-size: clamp(2.25rem, calc(5vw + 1rem), 3.5rem) !important;
    }
  
    .subheadline {
      color: $text-muted;
      font-size: 1.125rem;
      line-height: 1.6;
      margin-bottom: 2rem;
    }
  }
  
  .inside-box {
    background: #ffffff;
    border-left: 4px solid #0033ea;
    border-radius: 4px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    margin-bottom: 2rem;
  
    h3 {
      font-size: 1.6rem;
      color: $primary;
      margin-bottom: 1rem;
      font-family: Lato;

    }
  
    .features-list {
      list-style: none;
      padding-left: 0;
  
      li {
        position: relative;
        padding-left: 1.5rem;
        margin-bottom: 0.75rem;
        color: $text-dark;
        font-size: 1.05rem;
        line-height: 1.5;
        text-align: left;
        font-family: Lato;
  
        &:last-child { margin-bottom: 0; }
  
        &::before {
          content: "✓";
          position: absolute;
          left: 0;
          color: $accent;
          font-weight: bold;
        }
      }
    }
  }
  
  .authority-strip {
    display: flex;
    justify-content: center;
    gap: 2rem;
    border-top: 1px solid $border;
    padding-top: 1.5rem;
  
    .stat-item {
      display: flex;
      flex-direction: column;
  
      .stat-number {
        font-size: 1.6rem;
        font-weight: 800;
        color: $primary;
        font-family: Lato;
      }
  
      .stat-desc {
        font-size: 0.9rem;
        color: $text-muted;
        font-family: Lato;
      }
    }
  }
  
  .form-column {
    display: flex;
    align-items: flex-start;
  }
  
  .form-card {
    background: #ffffff;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 2rem;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05);
    text-align: left;
  
    .form-title {
      font-size: 1.4rem;
      color: $primary;
      font-weight: 700;
      margin-bottom: 0.5rem;
      font-family: Lato;
    }
  
    .form-subtitle {
      font-size: 0.9rem;
      color: $text-muted;
      margin-bottom: 1.5rem;
      line-height: 1.4;
      font-family: Lato;
    }
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  
    label {
      display: block;
      font-size: 0.85rem;
      font-weight: 600;
      color: $text-dark;
      margin-bottom: 0.5rem;
      display: flex;
      font-family: Lato;
    }
  
    input, select {
      width: 100%;
      padding: 0.75rem;
      border: 1px solid $border;
      border-radius: 6px;
      font-size: 0.95rem;
      color: $text-dark;
      background-color: #f8fafc;
      transition: all 0.2s ease;
      font-family: Lato;
  
      &:focus {
        outline: none;
        border-color: $accent;
        background-color: #ffffff;
        box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.1);
      }
    }
  }
  
  .submit-button {
    width: 100%;
    padding: 0.85rem;
    background-color: #0033ea;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: background-color 0.2s ease;
  
    &:hover {
      background-color: lighten(#0033ea, 15%);
    }
  
    &:disabled {
      background-color: $text-muted;
      cursor: not-allowed;
    }
  }
  
  .trust-line {
    margin-top: 1.25rem;
    font-size: 0.75rem;
    color: $text-muted;
    text-align: center;
    line-height: 1.4;
  }
  
  @media (min-width: 768px) {
    .copy-column {
      .headline {
        font-size: 3rem;
      }
    }
  }
  
  @media (min-width: 1024px) {
    .grid-layout {
      grid-template-columns: 1.2fr 0.8fr;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
  